import type { QueryClient } from "@tanstack/react-query";
import type { PostHog } from "posthog-js";
import { Outlet, RouteObject } from "react-router";
import { LoadingContainer } from "~/shared/components/ds/Spinner";
import { TopLevelRouteErrorHandler } from "~/shared/components/errors/Error";
import { PublicAppLayout } from "~/shared/components/PublicAppLayout";
import { getSharedRoutes } from "~/shared/shared.routes";

const PublicAppRoot = () => {
  return (
    <PublicAppLayout>
      <Outlet />
    </PublicAppLayout>
  );
};

export function PublicRoutes(queryClient: QueryClient, posthogClient?: PostHog): RouteObject[] {
  return [
    {
      Component: PublicAppRoot,
      hydrateFallbackElement: <LoadingContainer level="full" />,
      errorElement: <TopLevelRouteErrorHandler />,
      children: [...getSharedRoutes(queryClient, posthogClient)],
    },
  ];
}
